import { ApiResponse, axiosInstance } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { TAgent } from '../../agent/types/agent.type';

/**
 *
 */
export type TGetListAgentToTeamResponse = ApiResponse<TAgent[]>;
export type TGetListAgentToTeamParams = {
  teamId: string;
  search?: string;
};

export const getListAgentToTeam = async (params: TGetListAgentToTeamParams): Promise<TGetListAgentToTeamResponse> => {
  const url = `/team/list-user-to-add/${params.teamId}`;

  return axiosInstance.get(url, {
    params: {
      search: params?.search || '',
    },
  });
};

/**
 *
 */
export const GET_LIST_AGENT_TO_TEAM_QUERY_KEY = 'get-list-agent-to-team';

export const getListAgentToTeamQueryOptions = (data: TGetListAgentToTeamParams) => {
  return queryOptions({
    queryKey: [
      GET_LIST_AGENT_TO_TEAM_QUERY_KEY,
      {
        teamId: data?.teamId,
        search: data?.search,
      },
    ],
    queryFn: () => getListAgentToTeam(data),
  });
};

type TUseGetListAgentToTeamOptions = {
  params: TGetListAgentToTeamParams;
  queryConfig?: QueryConfig<typeof getListAgentToTeamQueryOptions>;
};

export const useGetListAgentToTeam = ({ queryConfig, params }: TUseGetListAgentToTeamOptions) => {
  return useQuery({
    ...getListAgentToTeamQueryOptions(params),
    ...queryConfig,
  });
};
